export default __webpack_public_path__ + "static/media/pmkt.c6d6efca.jpg";